import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import { useStyles } from "./M_GlobalSearch.styles";
import {
  SEARCH_ICONS,
  DEFAULT_SEARCH_ICON,
  SEARCH_STRINGS,
  RECENT,
} from "./M_GlobalSearch.config";
import { splitHighlight, getHighlightConfig } from "./M_GlobalSearch.helper";

const getIcon = (item) => {
  const key = (item.iconKey || item.entityType || "").toLowerCase();
  return SEARCH_ICONS[key] || DEFAULT_SEARCH_ICON;
};

const M_SearchResultsList = (props) => {
  const classes = useStyles();
  const {
    groups,
    showGroupLabel,
    showTypeChip,
    activeIndex,
    query,
    onSelect,
    onActivate,
    onClearRecent,
  } = props;
  let runningIndex = 0;

  const renderText = (text) =>
    splitHighlight(text, query).map((segment, index) =>
      segment.isMatch ? (
        <mark key={`seg-${index}`} className={classes.highlight}>
          {segment.text}
        </mark>
      ) : (
        <React.Fragment key={`seg-${index}`}>{segment.text}</React.Fragment>
      )
    );

  return (
    <>
      {groups.map((group) => {
        const startIndex = runningIndex;
        runningIndex += group.items.length;
        const isRecent = group.key === RECENT.GROUP_KEY;
        return (
          <div key={group.key}>
            {showGroupLabel &&
              (isRecent && onClearRecent ? (
                <div className={classes.groupHeader}>
                  <span className={classes.groupLabel}>{group.label}</span>
                  <button
                    type="button"
                    className={classes.groupAction}
                    onClick={onClearRecent}
                  >
                    {SEARCH_STRINGS.RECENT_CLEAR}
                  </button>
                </div>
              ) : (
                <div className={classes.groupLabel}>{group.label}</div>
              ))}
            {group.items.map((item, itemIndex) => {
              const globalIndex = startIndex + itemIndex;
              const isActive = globalIndex === activeIndex;
              const highlight = getHighlightConfig(item);
              return (
                <div
                  key={item.id || `${group.key}-${globalIndex}`}
                  data-index={globalIndex}
                  className={`${classes.row} ${isActive ? classes.rowActive : ""}`}
                  onMouseMove={() => onActivate(globalIndex)}
                  onClick={() => onSelect(item)}
                >
                  <span className={classes.avatar}>
                    <FontAwesomeIcon icon={getIcon(item)} />
                  </span>
                  <div className={classes.rowText}>
                    <div className={classes.heading}>
                      {highlight.heading ? renderText(item.heading) : item.heading}
                    </div>
                    {item.subHeading && (
                      <div className={classes.subHeading}>
                        {highlight.subHeading
                          ? renderText(item.subHeading)
                          : item.subHeading}
                      </div>
                    )}
                  </div>
                  <div className={classes.rowMeta}>
                    {item.tag && (
                      <span className={classes.tagChip} title={item.tag}>
                        {item.tag}
                      </span>
                    )}
                    {showTypeChip && item.entityType && (
                      <span className={classes.typeChip}>{item.entityType}</span>
                    )}
                    {isActive && (
                      <span className={classes.enterHint} aria-hidden="true">
                        <KeyboardReturnIcon fontSize="inherit" />
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

M_SearchResultsList.propTypes = {
  groups: PropTypes.array,
  showGroupLabel: PropTypes.bool,
  showTypeChip: PropTypes.bool,
  activeIndex: PropTypes.number,
  query: PropTypes.string,
  onSelect: PropTypes.func,
  onActivate: PropTypes.func,
  onClearRecent: PropTypes.func,
};

export default M_SearchResultsList;
